import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Dialog, FlatButton, TextField} from 'material-ui'
import {api} from "../../../../../api/index"
import {app} from "../../../../../config/constants";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { loadCompanies } from "../../../../../api/companies";
import { loadCampaignSettings } from "../../../../../api/settings/campaigns";

class AppCampaignsCreateDialogComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			campaign: {
				title     : '',
				type      : '',
				subject   : '',
				department: '',
				company: '',
			},
			companies: []
		};

		this.saveCampaign = this.saveCampaign.bind(this);
		this.handleState = this.handleState.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
	}

	componentDidMount() {
		loadCompanies();
		loadCampaignSettings();
	}

	saveCampaign(event) {

		api.campaigns.CreateCampaign(this.state.campaign).then( () => {
			this.setState({
				...this.state,
				campaign: {
					...this.state.campaign,
					title: '',
					type: '',
					subject: '',
					department: '',
					company: '',
				}
			});
		});

		event.preventDefault();
	}

	handleSelectChange(name, event, index, values) {
		this.setState({
			...this.state,
			campaign: {
				...this.state.campaign,
				[name]: values
			}
		});
	}

	handleState(event) {

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			...this.state,
			campaign: {
				...this.state.campaign,
				[name]: value
			}
		});
	}

	handleClose(event) {
		api.campaigns.closeDialog();
	}

	selectItems(items, name) {
		return items.map((item, key) => {
			return (
				<MenuItem
					key={key}
					insetChildren={true}
					checked={this.state[name] === item.key}
					value={item.key}
					primaryText={item.name}
				/>
			);
		});
	};

	render() {
		const actions = [
			<FlatButton
				label="Annuleren"
				primary={true}
				onClick={this.handleClose}
			/>,
			<FlatButton
				label="Opslaan"
				primary={true}
				onClick={this.saveCampaign}
			/>
		];

		return (
			<div>
				<Dialog
					title="Campagne toevoegen"
					actions={actions}
					modal={false}
					open={this.props.campaigns.modal.open}
					onRequestClose={this.handleClose}
				>
					<div className="grid-x grid-margin-x grid-margin-y">
						<div className="medium-12 cell">
							<label>
								Naam
								<TextField name={'title'} id="title" fullWidth={true} value={this.state.campaign.title} onChange={this.handleState} />
							</label>
						</div>
						<div className="medium-6 cell">
							<SelectField name={'type'} floatingLabelText={'Type'} value={this.state.campaign.type} maxHeight={200} fullWidth={true} onChange={this.handleSelectChange.bind(null, 'type')}>
								{this.selectItems(this.props.campaignSettings.types, 'type')}
							</SelectField>
						</div>
						<div className="medium-6 cell">
							<SelectField name={'subject'} floatingLabelText={'Onderwerp'} value={this.state.campaign.subject} maxHeight={200} fullWidth={true} onChange={this.handleSelectChange.bind(null, 'subject')}>
								{this.selectItems(this.props.campaignSettings.subjects, 'subject')}
							</SelectField>
						</div>
						<div className="medium-6 cell">
							<SelectField name={'department'} floatingLabelText={'Opdrachtgever'} value={this.state.campaign.department} maxHeight={200} fullWidth={true} onChange={this.handleSelectChange.bind(null, 'department')}>
								{this.selectItems(this.props.campaignSettings.departments, 'department')}
							</SelectField>
						</div>
						<div className="medium-6 cell">
							<SelectField name={'company'} floatingLabelText={'Bedrijf'} value={this.state.campaign.company} maxHeight={200} fullWidth={true} onChange={this.handleSelectChange.bind(null, 'company')}>
								{this.selectItems(this.props.companies.items, 'company')}
							</SelectField>
						</div>
					</div>
				</Dialog>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		campaigns       : state.campaigns,
		campaignSettings: state.campaignSettings,
		companies: state.companies
	};
};

export default connect(mapStateToProps, {
	loadCompanies,
	loadCampaignSettings
})(AppCampaignsCreateDialogComponent)


// WEBPACK FOOTER //
// ./src/application/components/campaigns/components/create/modal.js